module.exports = __webpack_public_path__ + "static/media/call-calling.e66d2b9d.svg";